module.exports = __webpack_public_path__ + "static/media/license_02.a18161fa.svg";